// Menü Tanımları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.productMenus';

export const inventoryProductMenusGuide = (t: TFunction): GuideContent => ({
  // Üstte menü bilgisi ve ekleme düğmeleri, altta menüdeki ürünler tablosu
  layout: 'stacked',
  title: t(`${G}.title`, 'Menü nasıl tanımlanır?'),
  intro: t(`${G}.intro`, 'Bu pencere, birlikte satılan ürünleri tek bir menü altında toplamanızı ve satışta her seferinde aynı içeriğin kullanılmasını sağlar.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    form: t(`${G}.regions.form`, 'Menü bilgisi ve ekleme'),
    list: t(`${G}.regions.list`, 'Menüdeki ürünler'),
    footer: t(`${G}.regions.footer`, 'Sil / Yazdır / Kapat'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Menüyü oluşturun'),
      text: t(`${G}.s1.text`, 'Ürünün henüz menüsü yoksa menü adını yazın; menü kodu ve açıklama isteğe bağlıdır. "Menü Oluştur" ile kaydedin.'),
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Ürün ekleyin'),
      text: t(`${G}.s2.text`, '"Ürün Ekle" ile menüye girecek ürünleri seçin. Seçilen ürünler için miktar, fire oranı (%) ve isteğe bağlı not girip ekleyin.'),
      tips: [
        t(`${G}.s2.tip1`, 'Menü içinde başka menü tanımlanamaz; yalnız normal ürünler eklenir. Bu kural satış akışını güvenli tutar.'),
        t(`${G}.s2.tip2`, '"Reçeteli" etiketli ürün satıldığında reçetesindeki malzemeler de stoktan düşer.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. Opsiyonlu ürün ekleyin'),
      text: t(`${G}.s3.text`, '"Opsiyonlu Ürün Ekle" ile müşteriye tek seçimli alternatifler sunun (ör. İçecek: Cola / Ayran). Opsiyon grubuna ad verin, ürünleri seçin ve birini varsayılan yapın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Aynı opsiyon grubundan satışta yalnız BİR ürün seçilebilir.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Satır menüsü: düzenle, sil, ekstra opsiyon'),
      text: t(`${G}.s4.text`, 'Tablodaki her ürün satırının sonundaki 3 nokta menüsünden satırı düzenleyebilir, silebilir veya ekstra opsiyon ekleyebilirsiniz.'),
      tips: [
        t(`${G}.s4.tip1`, 'Ekstra opsiyon, boy/üst seçenek içindir. Örn: Küçük Cola → Büyük Cola (+20₺).'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s5.title`, '5. Taslak kaydet ve uygula'),
      text: t(`${G}.s5.text`, 'İçeriği aynı olan çok sayıda menü varsa birini "Taslak Olarak Kaydet" ile saklayın, diğer menülerde "Taslaktan Uygula" ile tek tıkla ekleyin.'),
      tips: [
        t(`${G}.s5.tip1`, 'Taslak bu bilgisayarın tarayıcısında tutulur; başka bilgisayarda görünmez.'),
        t(`${G}.s5.tip2`, 'Uygularken menüde zaten olan ürünler atlanır, mevcut satırlar silinmez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Yazdırma ve menüyü silme'),
      text: t(`${G}.s6.text`, '"Yazdır" menü içeriğini yazdırır. "Menüyü Sil" menüyü tüm ürün ve ayarlarıyla siler; bu işlem geri alınamaz. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
